<style lang="scss" scoped>
.page-content {
  display: flex;

  position: relative;

  height: 100vh;

  background-color: #fff;

  flex-direction: column;
}
.reason {
  margin-bottom: 12px;
  padding-bottom: 12px;

  background-color: #fff;

  .more-reason {
    width: calc(100% - 24px);
    margin: 0 12px;
    padding: 5px 10px;

    border-radius: 5px;

    border: 1px solid #ebebeb;

    box-sizing: border-box;
    textarea {
      display: block;

      width: 100%;
      height: 80px;
      padding: 0;

      border: 0;

      outline: none;

      box-sizing: border-box;

      font-size: 12px;
      line-height: 20px;
      color: #333;

      resize: none;
    }
  }
}
.reason h4 {
  margin: 0 0 8px 0;

  padding-left: 12px;

  font-size: 14px;
  text-align: left;
}
.reason .tags {
  padding: 6px;

  font-size: 0;
  text-align: center;
}
.reason .tags li {
  display: inline-block;

  height: 30px;
  margin: 6px;
  padding: 0 11px;

  border-radius: 43px;

  border: 1px solid #ebebeb;

  font-size: 14px;
  line-height: 30px;
  color: #666;
}
.reason .tags li.selected {
  background-color: #fff;

  border-color: #ff7400;

  color: #ff7400;
}

.refund-detail {
  padding: 12px 0;

  background-color: #ffffff;
  h4 {
    margin: 0 0 8px 0;

    padding-left: 12px;
  }
  .gray-tip {
    font-size: 12px;
    color: #333;
    margin: 12px;
  }
  table {
    margin: 0 12px;

    border: 1px solid #ddd;

    tr {
      border-bottom: 1px solid #ddd;

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    .count {
      padding-left: 12px;

      text-align: left;

      span {
        font-size: 14px;
        color: #333;
      }

      label {
        font-size: 12px;
        color: #999;
      }
    }

    .description {
      padding: 0 12px;
    }
  }

  .tips {
    padding: 12px;

    font-size: 14px;
    color: #ff4e4e;
  }
}

.footer {
  width: 100%;
  height: 1rem;

  background-color: #fff;

  border-top: 1px solid #ddd;

  flex: none;

  button {
    float: right;

    width: 120px;
    height: 0.98rem;

    background: none;

    background-color: #0daf52;

    border: none;
    outline: none;

    line-height: 0.98rem;
    color: #fff;
  }
}
</style>

<template>
  <div class="page-content">
    <scroll-view :background="'#F5F5F5'">
      <div class="reason">
        <div class="tags">
          <h4>选择取消原因</h4>
          <ul>
            <li
              v-for="(tag, index) in cancelInfo.tags"
              :key="index"
              :class="{ selected: tag.id === reason.id }"
              @click="tagHandler(tag.id)"
            >
              {{ tag.content }}
            </li>
          </ul>
        </div>
        <div class="more-reason">
          <textarea
            v-model.trim="reason.more"
            maxlength="300"
            placeholder="有话说？点这里（限300字）"
            @keyup="moreReasonCheck"
            @paste="moreReasonCheck"
          ></textarea>
        </div>
      </div>
      <div v-if="refundDetailshow" class="refund">
        <div v-if="refundDetailshow" class="refund-detail">
          <h4>退款详情</h4>
          <div class="gray-tip">
            退款金额将原路返回，可能需要2-7个工作日到账
          </div>
          <!-- <table v-else>
            <tr>
              <td class="count">
                <span>￥{{ balanceText }}</span>
                <br />
                <label>预付款</label>
              </td>
              <td class="description">退回“我的钱包”</td>
            </tr>
            <tr>
              <td class="count">
                <span>￥{{ cashText }}</span>
                <br />
                <label>现金</label>
              </td>
              <td class="description">
                退款至银行卡、支付宝或微信等，可能需要2-7个工作日到账
              </td>
            </tr>
            <tr>
              <td class="count">
                <span>￥{{ cancelInfo.refund.detail.coupon }}</span>
                <br />
                <label>优惠券</label>
              </td>
              <td class="description">退回“我的优惠券”</td>
            </tr>
            <tr v-if="isHasEarnestMoney">
              <td class="count">
                <span>￥{{ cancelInfo.refund.detail.earnest_money }}</span>
                <br />
              </td>
              <td class="description">退回定金</td>
            </tr>
          </table> -->
          <p class="tips">温馨提醒：订单取消成功后,不能恢复</p>
        </div>
      </div>
    </scroll-view>
    <div class="footer">
      <button :class="themeBgColorClass" @click.prevent="submitConfirm">
        提交
      </button>
    </div>
  </div>
</template>

<script>
import { miniProgramEnv } from '@/defines/environment'
import ScrollView from '@/common/widgets/scroll_view'
import Url from '@mc/mc-utils/js/url/url'
import { API } from '@/api'
import { Bridge } from '@mc/mc-jsbridge'
import { navBar } from '@/utils/native_interactions/native_bar'
import { DialogAlert } from '@/utils/dialog.js'
import themeMixin from '@/common/mixins/theme'
export default {
  name: 'CancelOrder',
  components: {
    ScrollView
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '取消订单'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.selectedRefundWay = ''
      vm.reason.id = 0
      vm.reason.more = ''
      const url = new Url(window.location.href)
      const queries = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      // eslint-disable-next-line camelcase
      const order_id = queries.order_id || hashQuery.order_id
      const orderIds = queries.orderIds || hashQuery.orderIds || ''
      const orderItemIds = queries.orderItemIds || hashQuery.orderItemIds || ''
      vm.orderIds = orderIds
      vm.orderItemIds = orderItemIds
      // eslint-disable-next-line camelcase
      const selected_company_id =
        queries.selected_company_id || hashQuery.selected_company_id
      // eslint-disable-next-line camelcase
      vm.selected_company_id = selected_company_id || ''
      // eslint-disable-next-line camelcase
      const link_cancel_order_ids =
        queries.link_cancel_order_ids || hashQuery.link_cancel_order_ids || ''
      const linkCancelOrderItemIds =
        queries.linkCancelOrderItemIds || hashQuery.linkCancelOrderItemIds || ''
      const grayFlag = queries.grayFlag || hashQuery.grayFlag || ''
      // eslint-disable-next-line camelcase
      vm.link_cancel_order_ids = link_cancel_order_ids

      vm.linkCancelOrderItemIds = linkCancelOrderItemIds
      // eslint-disable-next-line eqeqeq
      vm.grayFlag = grayFlag == 1
      // eslint-disable-next-line camelcase
      // if (!order_id) return DialogAlert('未知订单')
      vm.getCancelOrderInfo(order_id)
    })
  },
  data() {
    return {
      selectedRefundWay: '',
      selected_company_id: '',
      orderIds: '',
      orderItemIds: '',
      reason: {
        id: 0,
        more: ''
      },
      link_cancel_order_ids: '',
      cancelInfo: {
        id: 0,
        tags: [],
        payWay: 0,
        payStatus: 0,
        isYufu: 0,
        refund: {
          detail: {
            totalAmount: 0,
            balance: 0,
            cash: 0,
            coupon: 0,
            earnest_money: ''
          }
        }
      },
      browerInfo: window.matrix,
      linkCancelOrderItemIds: '',
      grayFlag: false
    }
  },
  computed: {
    pagePaddingTop() {
      if (!miniProgramEnv.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },
    refundWay: {
      get: function () {
        if (this.selectedRefundWay) {
          return this.selectedRefundWay
        } else {
          return this.cancelInfo.payWay === 2 ? 'origin' : 'wallet'
        }
      },
      set: function (value) {
        this.selectedRefundWay = value
      }
    },
    refundDetailshow() {
      if (this.cancelInfo.payWay === 2 && this.cancelInfo.payStatus === 0) {
        return false
      } else {
        return true
      }
    },
    balanceText() {
      return this.refundWay === 'wallet'
        ? this.cancelInfo.refund.detail.totalAmount
        : this.cancelInfo.refund.detail.balance
    },
    cashText() {
      return this.refundWay === 'wallet'
        ? '0.00'
        : this.cancelInfo.refund.detail.cash
    },
    isHasEarnestMoney() {
      return this.cancelInfo.refund.detail.earnest_money !== ''
    }
  },
  methods: {
    goBack() {
      this.$back()
    },
    async getCancelOrderInfo(orderId) {
      try {
        const parmas = {
          order_id: orderId,
          selected_company_id: this.selected_company_id,
          orderIds: this.orderIds,
          orderItemIds: this.orderItemIds
        }
        const data = await API.cancelOrder.cancelOrderInfo(parmas)
        this.cancelInfo = {
          id: orderId,
          tags: data.tags,
          payWay: parseInt(data.payment_type),
          payStatus: parseInt(data.pay_status),
          isYufu: parseInt(data.is_yufu),
          refund: {
            detail: {
              totalAmount: data.total_amount,
              balance: data.used_balance_money,
              cash: data.paid_amount,
              coupon: data.coupon_discount,
              earnest_money: data.earnest_money
            }
          }
        }
      } catch (e) {
        this.$catch(e)
      }
    },
    tagHandler(id) {
      if (this.reason.id && this.reason.id === id) {
        this.reason.id = 0
        this.$track(this.$trackMap.orderCancel.cancelReason + '1', {
          content: encodeURIComponent(
            this.cancelInfo.tags.filter(tag => tag.id === id)[0].content
          )
        })
      } else {
        this.reason.id = id
        this.$track(this.$trackMap.orderCancel.cancelReason + '0', {
          content: encodeURIComponent(
            this.cancelInfo.tags.filter(tag => tag.id === id)[0].content
          )
        })
      }
    },
    submitConfirm() {
      const tag =
        this.cancelInfo && Array.isArray(this.cancelInfo.tags)
          ? this.cancelInfo.tags.find(tag => tag.id === this.reason.id)
          : undefined

      this.$track(this.$trackMap.orderCancel.btnSubmit + '0', {
        content: tag ? encodeURIComponent(tag.content) : ''
      })
      this.submit()
    },
    async submit() {
      let data = {
        order_id: this.cancelInfo.id,
        link_cancel_order_ids: this.link_cancel_order_ids || '',
        linkCancelOrderItemIds: this.linkCancelOrderItemIds || '',
        selected_company_id: this.selected_company_id,
        orderIds: this.orderIds,
        orderItemIds: this.orderItemIds
      }
      if (this.cancelInfo.payWay !== 2 || this.cancelInfo.payStatus !== 0) {
        data = Object.assign(data, {
          return_way: this.refundWay === 'wallet' ? 1 : 2
        })
      }
      if (this.reason.id) {
        data = Object.assign(data, {
          revoke_type: this.reason.id
        })
      }
      if (this.reason.more !== '') {
        data = Object.assign(data, {
          revoke_reason: this.reason.more
        })
      }
      this.$Loading()
      try {
        const res = await API.cancelOrder.submitCancelOrder(data)
        if (res.msg) {
          DialogAlert(res.msg).then(() => {
            Bridge.call('mcsc.refreshNotification', {
              type: 'CancelOrder',
              params: { cancelOrderStatus: 1 }
            })
            Bridge.navigateClose(false)
          })
        }
      } catch (e) {
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          DialogAlert(msg)
        }
      }
      this.$Loading.hide()
    },
    moreReasonCheck(e) {
      if (this.reason.more.length >= 300) {
        this.$toast({
          message: '字数限制300字以内',
          position: 'top'
        })
      }
    }
  }
}
</script>
